import { ChatPanelPill } from './ChatPanelPill';

interface ChatPanelPageContextPillProps {
  label: string;
  onDismiss: () => void;
}

/** States that the assistant can read the current page, and offers one click to stop it.
 *
 * It renders only while the page is genuinely being sent, so the pill is never a claim the
 * request does not back. */
export const ChatPanelPageContextPill = ({
  label,
  onDismiss,
}: ChatPanelPageContextPillProps) => (
  <ChatPanelPill
    label={label}
    onDismiss={onDismiss}
    dismissLabel="Stop sharing this page with the assistant"
  />
);
